import querystring from 'querystring';

const querystringToObj = (qs = window.location.search) => {
  if (qs[0] === '?') {
    qs = qs.substr(1);
  }
  return querystring.parse(qs);
};

export default querystringToObj;
